/**
 * Inputs panel for the Matrix Engine — left column listing the 5 data layers.
 */
export default function MatrixInputsPanel({ inputs }) {
  return (
    <div
      data-testid="matrix-inputs"
      className="h-full p-7 md:p-8 bg-card border-2 border-border rounded-2xl"
    >
      <div className="font-mono text-[0.6rem] uppercase tracking-[0.22em] text-primary/75 mb-4">
        Inputs · 5 data layers
      </div>
      <h3 className="font-display text-2xl md:text-3xl font-semibold leading-tight mb-6">
        Multiple data points. <em className="not-italic text-primary">All in one engine.</em>
      </h3>
      <ul className="divide-y divide-border/70">
        {inputs.map(({ icon: Icon, title, body }) => (
          <li
            key={title}
            data-testid={`matrix-input-${title.toLowerCase().replace(/\s+/g, "-")}`}
            className="flex items-start gap-4 py-4 first:pt-0 last:pb-0"
          >
            <Icon size={22} weight="duotone" className="text-primary flex-shrink-0 mt-1" />
            <div className="grid grid-cols-12 items-baseline gap-3 flex-1 min-w-0">
              <div className="col-span-12 sm:col-span-4 font-display text-base md:text-lg font-semibold leading-tight text-foreground">
                {title}
              </div>
              <p className="col-span-12 sm:col-span-8 text-[0.95rem] md:text-base text-foreground/75 leading-snug">
                {body}
              </p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
